import styled from "styled-components";
import { useEffect, useRef, useState } from "react";
import { Howl, Howler } from "howler";
import { AudioPlayIcon } from "cssReset/icon";
import AudioLoadingSpinner from "components/pieces/audio.loading.spinner";

interface DataProps {
  audioPath: string;
}

const InspectAudioItemBox = ({ audioPath }: DataProps) => {
  const audioRef = useRef<Howl | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    // audioPath가 바뀔 때마다 새로 생성
    audioRef.current = new Howl({
      src: [audioPath],
      html5: true, // 모바일 호환
      volume: 1, // ✅ 개별 음량 설정 (0.0 ~ 1.0)
      onend: () => setIsPlaying(false),
    });

    return () => {
      // 컴포넌트 언마운트 시 정리
      audioRef.current?.unload();
    };
  }, [audioPath]);

  const togglePlay = () => {
    const sound = audioRef.current;
    if (!sound) return;

    if (sound.playing()) {
      sound.pause();
      setIsPlaying(false);
    } else {
      sound.play();
      setIsPlaying(true);
    }
  };

  // 화면 벗어나면 오디오 종료
  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.stop();
        audioRef.current.unload();
        audioRef.current = null;
      }
    };
  }, []);

  return (
    <BoxWrap>
      <button
        onClick={togglePlay}
        className={isPlaying ? "loading" : ""}
        type="button"
      >
        {isPlaying ? <AudioLoadingSpinner /> : <AudioPlayIcon />}
      </button>
    </BoxWrap>
  );
};

export default InspectAudioItemBox;

const BoxWrap = styled.div`
  button {
    border: 1px solid #242629 !important;
    outline: none;
    background-color: white;
    border-radius: 0.5rem !important;
    width: 100px;
    height: 100px;
    box-shadow: none !important;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 4rem;
      height: 4rem;
    }
    &.loading {
      background-color: #ececec !important;
    }
  }
`;
